import React from 'react';
import Autosuggest from 'react-autosuggest';
import { Div, Flex, CenterY, PlaneIcon } from './hocs/withStyles';
import { highlightText } from './hocs/helpers';

const AirportAutoSuggest = ({
  airportSuggests,
  suggestAirports,
  clearAirportSuggs,
  airportInput,
  setAirportInput,
  setNewOrigin,
  formIsValid,
  setValid
}) => (
  <Autosuggest
    suggestions={airportSuggests.slice(0, 5)}
    onSuggestionsFetchRequested={({ value }) => {
      if (value.length < 12 && !value.includes('-')) {
        suggestAirports(value);
      }
    }}
    onSuggestionsClearRequested={clearAirportSuggs}
    getSuggestionValue={sugg => `${sugg.code} - ${sugg.name}`}
    renderSuggestion={(suggestion, { query }) => (
      <Flex>
        <Flex width="40px">
          <Div
            p={[1]}
            css={{
              color: '#484848',
              backgroundColor: '#F0F0F0',
              fontSize: '10px',
              maxHeight: '21px',
              minWidth: '14px'
            }}
          >
            {suggestion.code}
          </Div>
        </Flex>
        <Div>
          {highlightText(suggestion.name, query)}{' '}
          {suggestion.code.length > 3 && ' - All Airports'}
        </Div>
      </Flex>
    )}
    inputProps={{
      type: 'search',
      value: airportInput,
      placeholder: 'Your Home Airport',
      onChange: (e, { newValue }) => {
        setValid(true);
        if (!newValue) {
          setNewOrigin(null);
        }
        setAirportInput(newValue);
      }
    }}
    focusInputOnSuggestionClick={false}
    onSuggestionSelected={(e, { suggestion }) => {
      setNewOrigin(suggestion);
    }}
    renderInputComponent={inputProps => (
      <Div id="airport-suggest-input" css={{ position: 'relative' }}>
        <Flex
          justifyContent="center"
          width="34px"
          css={{ position: 'absolute', top: 0, left: 0 }}
        >
          <CenterY height="42px">
            <PlaneIcon />
          </CenterY>
        </Flex>
        <input
          {...inputProps}
          style={{
            width: '100%',
            border: formIsValid ? '' : '2px solid #FF1300'
          }}
        />
      </Div>
    )}
  />
);

export default AirportAutoSuggest;



// WEBPACK FOOTER //
// ./src/components/AirportAutoSuggest.js